import * as http from './base.api';
import AuthenticationUserInfo from '../models/authentication-userinfo.model';

export function login() {

    return http.get(`api/login`).then(response => {
        return response.data;
    }, (error) => {
        return Promise.reject(error)
    });
}

export function loginWithToken(token) {
    return http.get(`authentication/token?token=${token}`).then(response => {
        return new AuthenticationUserInfo(response.data);
    });
}
